import { getNinjaConfig } from '../../../config/ninja';
import { LAQUESIS_SURVEY_CSS_FILENAME, NINJA_CDN } from '../../../const';
import { loadCSS } from '../../../utils';

export let isCSSLoaded = false;

/**
 * Loads styles for surveys
 * @returns {Promise<void>}
 */
export function loadSurveyStyles() {
  const ninjaConfig = getNinjaConfig();

  return new window.Promise(resolve => {
    if (ninjaConfig.asyncSurveyStyles && !isCSSLoaded) {
      const theme = ninjaConfig.surveyTheme || 'default';
      const filename = `${LAQUESIS_SURVEY_CSS_FILENAME}-${theme}.css`;
      loadCSS(`${NINJA_CDN}/${filename}`, 'laquesisSurveyStyles', () => {
        isCSSLoaded = true;
        resolve();
      });
    } else {
      resolve();
    }
  });
}
